import { updateViewState, removeViewState, initViewState } from "@plannel/redux/modules/viewStates";
import { updateHistoryState, removeHistoryState } from "@plannel/redux/modules/HistoryState";
import { updateTabState, updateTabIndex, initTabState } from "@plannel/redux/modules/TabState";
import axiosUtils from "@plannel/utils/axios-bigint";
import { store } from "@plannel/redux/modules/store";
import { cloneDeep, isEmpty } from "lodash";
import { ISO_8601_REGEX } from "@plannel/utils/date-util";

const AUDIT_TRAIL_TS = ["createdTs","updatedTs"];
const OBJECT_INIT = {};
const ARRAY_INIT = [];

const createViewState = (viewName, searchCode = "", page = 0, pageSize = 100) => {
  return {
    viewName,
    searchCode,
    page,
    pageSize
  }
}

const createFilterViewState = (viewName, filter = OBJECT_INIT) => {
  return {
    viewName,
    filter,
  }
}

const createObjectState = (viewName, object = OBJECT_INIT) => {
  return {
    viewName,
    ...object
  };
}

const getViewState = (viewName) => {
  const { viewStates } = store.getState();
  // const viewStates = useSelector((store) => { return store.viewStates }, shallowEqual); equals store.getState();
  // useSeletor util은 seletor custom useHook 을 만들어서 사용;
  const viewState = cloneDeep(viewStates.viewInfos?.find((state) => {
    return state?.viewName === viewName;
  }));

  for(const key in viewState) {
    if(key !== "viewName" && !isEmpty(viewState[key])){
      const parseData = axiosUtils.parseJsonWithBigInt(viewState[key]);
      
      if(ISO_8601_REGEX.test(viewState[key]) && typeof parseData !== "object" && !AUDIT_TRAIL_TS.includes(key)){
        viewState[key] = new ZDate(parseData);
      } else {
        viewState[key] = parseData;
      }
    }
  }

  return viewState;
}

const getHistoryState = () => {
  const { historyState } = store.getState();

  return historyState;
}

const createTabsState = (keys = ARRAY_INIT, tabIndex = -1, object = OBJECT_INIT) => {
  return {
    tabKeys: keys,
    tabIndex,
    ...object
  };
}

const getTabState = () => {
  const { tabState } = store.getState();

  if (isEmpty(tabState.tabKeys)) {
    return tabState;
  }

  const state = cloneDeep(tabState);
  const persistProperty = '_persist';
  delete state[persistProperty];

  for (const key in state) {
    if (Object.prototype.hasOwnProperty.call(state, key)) {
      const parseData = axiosUtils.jsonbigParse(state[key]);
      state[key] = parseData;
    }
  }

  return state;
}

const reduxUtil = {
  createViewState,
  createFilterViewState,
  createObjectState,
  getViewState,
  getHistoryState,
  updateViewState,
  removeViewState,
  initViewState,
  updateHistoryState,
  removeHistoryState,
  createTabsState,
  updateTabState,
  updateTabIndex,
  initTabState,
  getTabState
}

export default reduxUtil;